export default __webpack_public_path__ + "static/regularblade-ae76698c863904a3ac680505a459ddd7.png";